<template>
    <div class="communication-channels-filter">
        <div class="channel-row" v-for="(label, key) in channelLabels" :key="key">
            <label class="channel-label">
                {{ label }}
            </label>

            <div class="filter-min-max">
                <div class="filter-label">
                    <select class="form-control" v-model="channels[key]" @change="changed">
                        <option value="indifferent">{{ t('segments-filters-indifferent') }}</option>
                        <option value="accepted">{{ t('segments-filters-accepted') }}</option>
                        <option value="not_accepted">{{ t('segments-filters-not_accepted') }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "communication-channels",
    props: {
        currentValue: {
            type: [String, Object],
            default: null,
        },
    },
    data() {
        return {
            channels: {
                whatsapp: "indifferent",
                sms: "indifferent",
                email: "indifferent",
                rcs: "indifferent",
            },
            channelLabels: {
                whatsapp: this.t("whatsapp"),
                sms: this.t("sms"),
                email: this.t("email"),
                rcs: this.t("rcs"),
            }
        };
    },
    mounted() {
        this.initializeValue();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        initializeValue() {
            if (!this.currentValue) return;

            try {
                const parsed = typeof this.currentValue === 'string'
                    ? JSON.parse(this.currentValue)
                    : this.currentValue;

                this.channels = { ...this.channels, ...parsed };
            } catch (e) {
                console.warn("Erro ao parsear filtro de canais:", e);
            }
        },

        changed() {
            this.$emit("changed", this.channels);
        },
    }
};
</script>

<style lang="scss" scoped>
.communication-channels-filter {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 5px 0;
}

.channel-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.channel-label {
    margin: 0;
    font-size: 14px;
    color: #555;
    min-width: 100px;

    i {
        margin-right: 5px;
        color: #777;
        width: 16px;
        text-align: center;
    }
}

select,
select:focus {
    background-color: transparent;
    border: transparent;
    outline: none;
    box-shadow: none;
    padding: 0 5px 0 0;
    margin: -7px 0;
    cursor: pointer;
    text-align: right;
    direction: rtl;
}
</style>
